import { render } from "./ShopConstraints.vue?vue&type=template&id=5889f60f"
import script from "./ShopConstraints.vue?vue&type=script&lang=js"
export * from "./ShopConstraints.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__